import React from 'react';

const FileSearchCornerIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path
                d="M11.1 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.589 3.588A2.4 2.4 0 0 1 20 8v3.25"/>
            <path d="M14 2v5a1 1 0 0 0 1 1h5"/>
            <path d="m21 22-2.88-2.88"/>
            <circle cx="16" cy="17" r="3"/>
        </svg>
    );
};

export default FileSearchCornerIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/FileSearchCornerIcon.jsx